import {connect} from '@gisatcz/ptr-state';
import Select from '../../../../../../state/Select';
import Presentation from './presentation';

const mapStateToProps = state => {
	return {
		configuration: Select.app.getLocalConfiguration(state, 'data'),
		activeDivision: Select.components.get(
			state,
			'controlPanel',
			'activeDivision'
		),
	};
};

export default connect(mapStateToProps)(Presentation);
